import {
  Div,
  Text as TextUI
} from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'

const Text = ({ number, title, description }) => {

  const { isTab } = useResponsive()

  return (
    <Div
      gridArea='text'
      display='flex'
      flexDirection='column'
      alignItems={isTab ? 'center' : 'start'}
      marginBottom={32}
    >
      <Div
        height={24}
        width={24}
        borderRadius={6}
        backgroundColor='#F4F4F5'
        display='grid'
        placeItems='center'
      >
        <TextUI size='xs' weight='semibold'>
          {number}
        </TextUI>
      </Div>

      <Div marginTop={8} marginBottom={12}>
        <TextUI size='xl' color='headline' align='center'>
          {title}
        </TextUI>
      </Div>

      <Div width={290}>
        <TextUI size='sm' align={isTab ? 'center' : 'left'}>
          {description}
        </TextUI>
      </Div>
    </Div>
  )
}

export default Text